import React, { useState } from "react";
import styles from "./ChildReqBox.module.css";
import { ChildrenRequirementDetailsSidePanel, CustomButton, icon, IconComponent } from "../..";
import { translate, translateDateTime } from "../../../providers";

const ChildReqBox = ({
	deliverableName,
	isGlobalDeliverables,
	childReq,
	parentReqId,
	phaseLocked = false,
	selectedId,
	onSelectRequirement,
}) => {
	const [selectedChildrenRequirement, setSelectedChildrenRequirement] = useState(null);
	const handleOpenDetails = () => {
		setSelectedChildrenRequirement(childReq);
	};
	const handleCloseDetails = () => {
		setSelectedChildrenRequirement(null);
	};
	const handleSelectRequirement = () => {
		if (isGlobalDeliverables) {
			onSelectRequirement(childReq, deliverableName, phaseLocked);
		}
	};
	const getReqIdStringValue = () => {
		let newId = `${childReq?.id}-${childReq?.informationId}`;
		if (childReq?.informationRef) {
			newId = `${newId}(${childReq?.informationRef})`;
		}
		return newId;
	};
	return (
		<div
			className={styles.container}
			data-is-global={isGlobalDeliverables}
			data-is-selected={selectedId === childReq.id}
			role="presentation"
			onClick={handleSelectRequirement}
		>
			{!!childReq.documentOutName && <div className={styles.deliverableName}>{childReq.documentOutName}</div>}
			<div className={styles.title}>
				<div className={styles.titleText}>{childReq.title}</div>
				{!isGlobalDeliverables && (
					<CustomButton color="secondary" size="sm" variant="outlined" onClick={handleOpenDetails}>
						{translate("common:btn.details")}
					</CustomButton>
				)}
			</div>
			<div className={styles.content}>{childReq.content}</div>
			<div className={styles.additionalInfo}>{childReq.additionalInfo}</div>
			<div className={styles.idInfo}>{getReqIdStringValue()}</div>
			<div className={styles.updateDate}>
				<IconComponent color="var(--grey-500)" icon={icon.faArrowsRotate} size="xs" />
				{translate("common:children-requirements.last-synchronization")}{" "}
				{translateDateTime(childReq.modifiedDate)}
			</div>
			<ChildrenRequirementDetailsSidePanel
				childrenRequirement={selectedChildrenRequirement}
				deliverableName={deliverableName}
				isPhaseLocked={phaseLocked}
				parentReqId={parentReqId}
				onClose={handleCloseDetails}
			/>
		</div>
	);
};

export default ChildReqBox;
